import { Glue42Core } from "@glue42/core";

import { Glue42Office} from "../../../glue4office";
import {isOutlookEnabled} from "../helpers/index";
import {createItem} from "../helpers/createItem";

export const createTask = (agm: Glue42Core.AGM.API, task?: Glue42Office.Outlook.TaskParams, options?: Glue42Office.Outlook.NewTaskOptions) =>
    new Promise<void>((resolve, reject) => {
        if (!isOutlookEnabled(agm)) {
            reject(`The method "newTask" is not available`);
            return;
        }

        createItem(agm, task, "task", options)
            .then(() => resolve())
            .catch(reject);
    });
